export default {
  routerRoot: '/',
  ...__CONFIG__
}



// WEBPACK FOOTER //
// ./client/config.js